import { render, staticRenderFns } from "./agunanarusdokumen.vue?vue&type=template&id=fbd5b392&scoped=true&"
import script from "./agunanarusdokumen.vue?vue&type=script&lang=js&"
export * from "./agunanarusdokumen.vue?vue&type=script&lang=js&"
import style0 from "./agunanarusdokumen.vue?vue&type=style&index=0&id=fbd5b392&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd5b392",
  null
  
)

export default component.exports